import { HashRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout.jsx';

import Home           from './pages/Home.jsx';
import DayInLife      from './pages/DayInLife.jsx';
import Courses        from './pages/Courses.jsx';
import ScheduleBuilder from './pages/ScheduleBuilder.jsx';
import Clubs          from './pages/Clubs.jsx';
import SportsAndPE    from './pages/SportsAndPE.jsx';
import Events         from './pages/Events.jsx';
import Rules          from './pages/Rules.jsx';
import Timeline       from './pages/Timeline.jsx';
import FAQ            from './pages/FAQ.jsx';
import People         from './pages/People.jsx';
import Notes          from './pages/Notes.jsx';
import NotFound       from './pages/NotFound.jsx';

export default function App() {
  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/"                 element={<Home />} />
          <Route path="/day-in-the-life"  element={<DayInLife />} />
          <Route path="/courses"          element={<Courses />} />
          <Route path="/schedule-builder" element={<ScheduleBuilder />} />
          <Route path="/clubs"            element={<Clubs />} />
          <Route path="/sports-pe"        element={<SportsAndPE />} />
          <Route path="/events"           element={<Events />} />
          <Route path="/rules"            element={<Rules />} />
          <Route path="/timeline"         element={<Timeline />} />
          <Route path="/faq"              element={<FAQ />} />
          <Route path="/people"           element={<People />} />
          <Route path="/notes"            element={<Notes />} />
          <Route path="*"                 element={<NotFound />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
}
